import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import CaseTutorialPage from '../../components/CaseStudy/CaseTutorialPage';

const CaseTutorialPageRoute = () => (
  <ProtectedRoute requiresAuth={true}>
    <CaseTutorialPage />
  </ProtectedRoute>
);

export default CaseTutorialPageRoute;
